import { Day } from '@/domain/termine/type';
import { Termin } from '@/domain/termine/shared/types/Termin';
import { DayCell } from '@/domain/termine/features/Calendar/shared/DayCell/DayCell';
import {
  useCalendarContext,
  CalendarContext,
} from '@/domain/termine/features/Calendar/shared/CalendarContext';

interface CalendarWeekProps {
  week: Day[];
  termine: Termin[];
}

export function CalendarWeek({ week, termine }: CalendarWeekProps) {
  const props = useCalendarContext();

  return (
    <div className="grid grid-cols-7">
      {week.map((day, colIndex) => (
        <CalendarContext.Provider
          key={day.format('DD-MM-YYYY')}
          value={{
            ...props,
            colIndex,
          }}>
          <DayCell key={day.format('DD-MM-YYYY')} day={day} termine={termine} />
        </CalendarContext.Provider>
      ))}
    </div>
  );
}
